<template>
    <div>
        <b-button variant="primary" class="btn-rounded px-3 py-2" @click="updatePlanModal = true">
            UPDATE SUBSCRIPTION
        </b-button>
        <b-button variant="outline" class="btn-rounded px-3 py-2" @click="updatePaymentMethodModal = true">
            UPDATE PAYMENT METHOD
        </b-button>

        <b-modal v-model="updatePlanModal"
                 lazy
                 @hide="selectedPriceId = currentPriceId"
                 title="Update Subscription"
                 @ok="handleUpdateSubscription">
            <p class="mb-2">Hi {{ username }}, you can quickly update your subscription package here.</p>
            <b-form-select
                    class="large-bootstrap-select"
                    v-model="selectedPriceId"
                    :options="priceOptions"/>
            <template #modal-footer="{ ok, cancel, hide }">
                <div class="d-flex justify-content-between w-100">
                    <b-button variant="outline" class="btn-rounded" @click="cancel()">
                        Cancel
                    </b-button>

                    <b-button variant="primary" class="btn-rounded" @click="ok()"
                              :disabled="selectedPriceId === currentPriceId">
                        UPDATE
                    </b-button>
                </div>

            </template>
        </b-modal>

        <b-modal v-model="updatePaymentMethodModal"
                 lazy
                 title="Update Payment Method">

            <p class="mb-2">Hi {{ username }}, you can update your payment methods here.</p>

            <PaymentMethodManager :payment-methods-url="paymentMethodsManagerData.paymentMethodsUrl"
                                  :max-payment-methods="paymentMethodsManagerData.maxPaymentMethods"
                                  :initial-payment-methods="paymentMethodsManagerData.paymentMethods"
                                  :selected-payment-method-id="paymentMethodsManagerData.selectedPaymentMethodId"
                                  :selectable="true"
                                  :removable="true"
                                  @onSelect="selectedPaymentMethod = arguments[0]"
                                  @onRemove="selectedPaymentMethod = null"
                                  :organization="paymentMethodsManagerData.organization"/>

            <template #modal-footer="{ ok, cancel, hide }">
                <div class="d-flex justify-content-between w-100">
                    <b-button variant="outline"
                              class="btn-rounded"
                              @click="cancel()">
                        CANCEL
                    </b-button>

                    <b-button variant="primary"
                              class="btn-rounded"
                              @click="handleUpdatePaymentMethod"
                              :disabled="loading || !selectedPaymentMethod || selectedPaymentMethod.stripe_id === paymentMethodsManagerData.selectedPaymentMethodId">
                        UPDATE
                    </b-button>
                </div>

            </template>
        </b-modal>
    </div>
</template>

<script>
import PaymentMethodManager from "../PaymentMethods/PaymentMethodManager";
import GeneralMixins from "../../../mixins/GeneralMixins";

export default {

  props: ['plans', 'currentPriceId', 'paymentMethodsManagerData', 'username', 'subscription'],
  mixins: [GeneralMixins],

  data() {
    return {
      selectedPaymentMethod: null,
      selectedPriceId: this.currentPriceId,
      updatePlanModal: false,
      updatePaymentMethodModal: false,
      loading: false
    }
  },

  computed: {

    paymentMethodStripeId() {
      if (!this.selectedPaymentMethod) {
        return null
      }
      return this.selectedPaymentMethod.stripe_id
    },

    currentPrices() {
      if (this.currentPlan) {
        const identifier = this.currentPlan.identifier
        return this.plans.filter(p => p.identifier === identifier).map(p => p.prices).flatten()
      } else {
        // the current plan is not available anymore. show prices from the same tier if possible
        return this.plans.filter(p => p.identifier === this.subscription.identifier).map(p => p.prices).flatten()
      }
    },

    currentPlan() {
      return this.plans.find(p => p.prices.find(pr => pr.id === this.currentPriceId))
    },

    priceOptions() {
      return this.currentPrices.map(price => {
        return {
          value: price.id,
          text: `${price.name} - Renews each ${price.interval}`
        }
      })
    },

  },

  methods: {
    productPriceUrl(priceID) {
      return `/customers/subscriptions/new?price_id=${priceID}`
    },

    handleUpdateSubscription() {
      window.location.href = this.productPriceUrl(this.selectedPriceId)
    },

    handleUpdatePaymentMethod() {
      if (!this.subscription.id || !this.selectedPaymentMethod) {
        return
      }

      this.loading = true
      this.$http.patch(`/customers/subscriptions/${this.subscription.id}/change_payment_method`, {
        stripe_payment_method_id: this.selectedPaymentMethod.stripe_id
      }).then(fulfilled => {
        location.reload()
      }, rejected => {
        this.loading = false
        this.showErrorToast("There was an error while updating the payment method");
      })
    }
  },

  components: {PaymentMethodManager}
}
</script>